import FixedBanner from "./banners/fixedBanner";
import PropTypes from "prop-types";
import {mostRecentOfferCtaUrl} from "../models/variableCopywriting";


export default function NavigationBar(props) {

    function nextMonth() {
        const today = new Date();
        const nextMonthDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        return (
            <div>{nextMonthDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</div>
        )
    }

    return (
        <div>
            <div className="">
                <header className="vA">
                    <div className="container">
                        <button id="mobile-nav-button" className="expanded-menu" aria-expanded="false"
                                aria-controls="mobile-nav">
                            <div className="open" aria-label="Open the menu">
                                <svg aria-hidden="true" width="71" height="13" viewBox="0 0 71 13" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <line y1="9.5" x2="25" y2="9.5" stroke="white" stroke-width="3"/>
                                    <line y1="3.5" x2="25" y2="3.5" stroke="white" stroke-width="3"/>
                                    <path
                                        d="M34.787 11H32.707V1.9H36.243L37.92 7.984L39.584 1.9H43.042V11H40.65V4.305L38.752 11H36.685L34.787 4.344V11ZM44.8148 11V1.9H51.4058V3.668H47.3108V5.462H50.8208V7.217H47.3108V9.232H51.4058V11H44.8148ZM55.3373 11H53.1013V1.9H55.4673L58.7043 7.061V1.9H60.9403V11H58.6913L55.3373 5.657V11ZM65.1651 7.737C65.1651 8.881 65.6721 9.362 66.5431 9.362C67.4141 9.362 67.9211 8.881 67.9211 7.737V1.9H70.3261V7.373C70.3261 9.739 69.0651 11.195 66.5041 11.195C63.9301 11.195 62.6691 9.739 62.6691 7.373V1.9H65.1651V7.737Z"
                                        fill="white"/>
                                </svg>
                            </div>
                            <div className="close" aria-label="Close the menu">
                                <svg aria-hidden="true" width="77" height="37" viewBox="0 0 77 37" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd"
                                          d="M16.3787 18.4999L8.6005 26.2781L10.7218 28.3994L18.5 20.6213L26.2782 28.3994L28.3995 26.2781L20.6213 18.4999L28.3995 10.7218L26.2782 8.60044L18.5 16.3786L10.7218 8.60044L8.60051 10.7218L16.3787 18.4999Z"
                                          fill="white"/>
                                    <path
                                        d="M40.787 23H38.707V13.9H42.243L43.92 19.984L45.584 13.9H49.042V23H46.65V16.305L44.752 23H42.685L40.787 16.344V23ZM50.8148 23V13.9H57.4058V15.668H53.3108V17.462H56.8208V19.217H53.3108V21.232H57.4058V23H50.8148ZM61.3373 23H59.1013V13.9H61.4673L64.7043 19.061V13.9H66.9403V23H64.6913L61.3373 17.657V23ZM71.1651 19.737C71.1651 20.881 71.6721 21.362 72.5431 21.362C73.4141 21.362 73.9211 20.881 73.9211 19.737V13.9H76.3261V19.373C76.3261 21.739 75.0651 23.195 72.5041 23.195C69.9301 23.195 68.6691 21.739 68.6691 19.373V13.9H71.1651V19.737Z"
                                        fill="white"/>
                                </svg>
                            </div>
                        </button>

                        <div className="left-side">
                            <div className="language"><a style={{display: "none"}} href="/es">
                                <svg width="30" height="28" viewBox="0 0 30 28" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="14" cy="14" r="13.5" stroke="#1D58BA"/>
                                    <path
                                        d="M7.39289 18V11H13.3729L13.4429 12.55H9.21289V13.67H12.5729V15.14H9.21289V16.45H13.5729L13.5129 18H7.39289ZM18.0191 18.17C16.7491 18.17 15.7591 17.9 14.8391 17.5V15.74H14.8491C15.9391 16.31 17.0991 16.62 18.0791 16.62C18.9191 16.62 19.3491 16.39 19.3491 15.99C19.3491 15.58 19.0291 15.46 17.4791 15.2C16.0491 14.97 14.8191 14.53 14.8191 13.13C14.8191 11.89 15.8791 10.83 18.0991 10.83C18.9891 10.83 19.9591 11.04 20.7591 11.43V13.18H20.7491C19.9291 12.69 18.8591 12.38 17.9591 12.38C17.0691 12.38 16.6991 12.62 16.6991 13C16.6991 13.49 17.3691 13.54 18.5391 13.75C19.9691 14 21.2191 14.4 21.2191 15.9C21.2191 16.9 20.5491 18.17 18.0191 18.17Z"
                                        fill="#2755A2"/>
                                </svg>
                            </a>
                            </div>
                            <div className="right-menu">
                                <nav className="primary-nav-right">
                                    <ul id="menu-header-menu-right" className="menu">
                                        <li id="menu-item-340"
                                            className="menu-item menu-item-type-custom menu-item-object-custom menu-item-340">
                                            <a target="_self" rel="noopener"
                                               href="/services"
                                               className="whitespace-nowrap custom-font text-2xl"
                                               data-ps2id-api="true">Services</a>
                                        </li>
                                        <li id="menu-item-34"
                                            className="menu-item menu-item-type-custom menu-item-object-custom menu-item-340">
                                            <a target="_self" rel="noopener"
                                               href="/seo-retainer"
                                               className="whitespace-nowrap custom-font text-2xl"
                                               data-ps2id-api="true">Retainer +</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>


                        <div className="logo-center">
                            <div className="logo"><a id='main-url' href='/'>
                                <img id="main-logo" className="rounded-xl" src="/media/horizontal-logo.webp"
                                     itemProp="logo"
                                     alt="HerStory SEO: Home"/>
                                <span id="main-name" className="sr-only">HerStory SEO: Home</span> </a>
                            </div>
                        </div>
                        <div className="right-side">
                            <div className="right-menu">
                                <nav className="primary-nav-right">
                                    <ul id="menu-header-menu-right" className="menu">
                                        <li id="menu-item-340"
                                            className="menu-item menu-item-type-custom menu-item-object-custom menu-item-340">
                                            <a target="_self" rel="noopener"
                                               href="/#free-seo"
                                               className="whitespace-nowrap custom-font text-2xl"
                                               data-ps2id-api="true">{nextMonth()}</a>
                                        </li>
                                        {/*<li id="menu-item-339"*/}
                                        {/*    className="menu-item menu-item-type-custom menu-item-object-custom menu-item-339">*/}
                                        {/*    <a target="_blank" rel="noopener" href="/shop"*/}
                                        {/*       className="whitespace-nowrap"*/}
                                        {/*       data-ps2id-api="true">Learn</a>*/}
                                        {/*</li>*/}
                                    </ul>
                                </nav>
                            </div>
                            <div className="btn-group hide-on-small">
                                <a className="button" href={`signup`} target="_blank">
                                    Start&nbsp;now
                                </a>
                            </div>
                        </div>
                    </div>
                </header>

                {

                    !Boolean(props.shouldHidePromotionalBanner) &&
                        <div className="fixed bottom-20 left-0" style={{zIndex: 9999}}>
                            <div>
                                <FixedBanner/>
                            </div>
                        </div>
                }
            </div>


            {/* MOBILE VIEW */}
            <div id="mobile-nav" aria-labelledby="mobile-nav-button">
                <div id="mobile-nav-items" role="dialog">
                    <nav className="primary-mobile-menu">
                        <ul id="menu-mobile-menu" className="menu">
                            <li id="menu-item-487"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-292 current_page_item menu-item-487">
                                <a href="/" aria-current="page" data-ps2id-api="true">
                                    <div className="custom-font">Home</div>
                                </a>
                            </li>
                            <li id="menu-item-401"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-401">
                                <a href="/services" data-ps2id-api="true">
                                    <div className="custom-font">Services</div>
                                </a>
                            </li>
                            <li id="menu-item-402"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-402">
                                <a href="/seo-retainer" data-ps2id-api="true">
                                    <div className="custom-font">Retainer +</div>
                                </a>
                            </li>
                            <li id="menu-item-447"
                                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-447">
                                <a href="/#free-seo" data-ps2id-api="true">
                                    <div className="custom-font">{nextMonth()}</div>
                                </a>
                            </li>
                            <li id="menu-item-341"
                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-341">
                                <a target="_blank" rel="noopener"
                                   href="/contact-us"
                                   data-ps2id-api="true">
                                    <div className="custom-font">Contact Us</div>
                                </a>
                            </li>
                            <li id="menu-item-342"
                                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-342">
                                <a target="_blank" rel="noopener" href={`/signup`}
                                   data-ps2id-api="true">
                                    <div className="custom-font">Start Now</div>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    )
}

NavigationBar.propTypes = {
    shouldHidePromotionalBanner: PropTypes.bool,
}

NavigationBar.defaultProps = {
    shouldHidePromotionalBanner: false,
}